import { Injectable, OnDestroy } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { IndexedDBService } from './indexedDB.service';

@Injectable({
  providedIn: 'root',
})
export class OfflineService extends IndexedDBService implements OnDestroy {
  constructor(public indexdbService: NgxIndexedDBService) {
    super(indexdbService);
    this.storeName = 'offline';
  }
}
